import React, { useEffect } from "react"
import ArticleDetail from '@/modules/Article'
import { initAnalytics } from '@service/tracking_service'
import { getIdFromUrl, init } from '@lib/utils'

const Article = (props: any) => {
  const { pageContext } = props || {}
  const id = getIdFromUrl() || ''
  useEffect(() => {
    init()
    initAnalytics()
  }, [])
  return (
    <ArticleDetail id={id} pageContext={pageContext} />
  )
}
export default Article
